import React, { Component, ChangeEvent } from 'react';
import { IAddVideoQuestions } from '../../../../models/components/add-activity';
import { IQuestionData } from '../../../../models/action/video';
import { SelectNoneAsync } from '../../../../components/input/select/main';
import { DatetimeInput } from '../../../../components/input/date-time/main';
import Moment from 'moment';
import { Guid } from 'guid-typescript';
import Translator from '../../../../core/i18n';

const T = Translator.create();

interface IQuestion {
    question: IQuestionData;
    inputTextAnswer: string;
    inputTextfeedback: string;
    inputTextQuestion: string;
    inputTextTime: string;
}

export class Questions extends Component<IAddVideoQuestions, IQuestion> {

    inputTimeFormat = 'HH:mm:ss';

    constructor(props: any) {
        super(props);
        this.state = {
            question: this.props.question!,
            inputTextAnswer: '',
            inputTextfeedback: '',
            inputTextQuestion: '',
            inputTextTime: '',
        };
        this.onClickAddChoice = this.onClickAddChoice.bind(this);
        this.onClickDeleteChoice = this.onClickDeleteChoice.bind(this);
        this.onChangeTextAnswer = this.onChangeTextAnswer.bind(this);
        this.onChangeTextfeedback = this.onChangeTextfeedback.bind(this);
        this.onChangeTextQuestion = this.onChangeTextQuestion.bind(this);
        this.onChangeTextTime = this.onChangeTextTime.bind(this);
    }
    
    public setData() {
        this.props.questionData!.questions[this.props.index!] = this.state.question;
    }

    public onClickAddChoice() {
        if (this.state.inputTextAnswer.length > 0) {
            const array = this.state.question;
            if (array.videoTestChoices === null) {
                array.videoTestChoices = [];
            }
            array.videoTestChoices.push({
                testChoiceId: null,
                choiceText: this.state.inputTextAnswer,
                feedBack: this.state.inputTextfeedback,
                isAnswer: false
            });
            this.setState({ question: array, inputTextAnswer: '', inputTextfeedback: '', inputTextQuestion: '' }, this.setData);
        }
    }

    public onClickDeleteChoice(choiceIndex: number) {
        const array = this.state.question;
        if (array.videoTestChoices !== null) {
            array.videoTestChoices.splice(choiceIndex, 1);
            this.setState({ question: array }, this.setData);
        }
    }

    public onChangeCheckBox(event: ChangeEvent<HTMLInputElement>, questionIndex: number, choiceIndex: number) {
        if (event) {
            const question = this.props.questionData!.questions[questionIndex];
            if (question.videoTestChoices !== null) {
                question.videoTestChoices.forEach(choice => {
                    choice.isAnswer = false;
                });
                question.videoTestChoices[choiceIndex].isAnswer = event.target.checked;
                this.setState({ question });
            }
        }
    }

    public onChangeTextAnswer(event: ChangeEvent<HTMLInputElement>) {
        if (event) {
            this.setState({ inputTextAnswer: event.target.value });
        }
    }

    public onChangeTextfeedback(event: ChangeEvent<HTMLInputElement>) {
        if (event) {
            this.setState({ inputTextfeedback: event.target.value });
        }
    }

    public onChangeTextQuestion(event: ChangeEvent<HTMLInputElement>, questionIndex: number) {
        if (event) {
            const question = this.props.questionData!.questions[questionIndex];
            question.question = event.target.value;
            this.setState({ question });
        }
    }

    public onChangeTextTime(event: any, questionIndex: number, type: string) {
        if (event) {
            const inputTime = (typeof event === 'object') ? Moment(event[0]) : Moment(event, this.inputTimeFormat);
            const convertedTotalSeconds = (Moment(inputTime).hour() * 3600) + (Moment(inputTime).minute() * 60) + (Moment(inputTime).second());
            const question = this.props.questionData!.questions[questionIndex];

            if (type === "showTime") {
                question.showOnSecond = convertedTotalSeconds === 0 ? convertedTotalSeconds + 1 : convertedTotalSeconds;
            } else if (!this.state.question.continueEvenWrong) {
                question.goBackTo = convertedTotalSeconds;
            }
            this.setState({ question });
        }
    }

    public onChangeSelectCondition(selectValue: any, questionIndex: number) {
        if (selectValue) {
            const question = this.props.questionData!.questions[questionIndex];
            question.continueEvenWrong = selectValue.value;
            question.goBackTo = 0;
            this.setState({ question });
        }
    }

    public getTimeValue(type: string) {

        if (type === "goBackTime") {
            return Moment.utc(this.props.question!.goBackTo * 1000).format(this.inputTimeFormat);
        } else {
            return Moment.utc(this.props.question!.showOnSecond * 1000).format(this.inputTimeFormat);
        }
    }

    public render() {
        return (
            <div id={'card' + this.props.index} key={this.props.index} className="card" ref={this.props.questionRef}>
                <div className="card-header" id={'heading' + this.props.index!.toString()}>
                    <h5 className="mb-0">
                        <button
                            className="btn btn-link"
                            type="button"
                            data-toggle="collapse"
                            data-target={'#collapse' + this.props.index!.toString()}
                            aria-expanded="true"
                            aria-controls={'collapse' + this.props.index!.toString()}
                        >
                            <i className="material-icons">menu</i> {T.t('r_question')} {this.props.index! + 1} (
                            {this.getTimeValue("showTime")})
                        </button>
                    </h5>
                </div>

                <div
                    id={'collapse' + this.props.index!.toString()}
                    className="collapse show"
                    aria-labelledby={'heading' + this.props.index!.toString()}
                    data-parent="#accordionExample"
                >
                    <div className="card-body">
                        <h5>{T.t('r_question')}</h5>
                        <div className="form-input form-group">
                            <input
                                name="answer"
                                // tslint:disable-next-line:jsx-no-lambda
                                onChange={e => this.onChangeTextQuestion(e, this.props.index!)}
                                value={this.props.question!.question}
                                type="text"
                                placeholder={T.t('r_ask_question')}
                                required={undefined}
                            />
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <h5>{T.t('r_show_time')}</h5>
                                <DatetimeInput
                                    value={this.getTimeValue("showTime")}
                                    minTime={"00:00:01"}
                                    enableSeconds={true}
                                    datePickerId={"questionTime" + this.props.index}
                                    mode="time"
                                    dateFormat={this.inputTimeFormat}
                                    isHideLabel={true}
                                    pattern={'[0-9]{2}:[0-9]{2}:[0-9]{2}'}
                                    timeFormat='00:00:00'
                                    // tslint:disable-next-line:jsx-no-lambda
                                    onChange={(e: any) => this.onChangeTextTime(e, this.props.index!, "showTime")}
                                />
                            </div>
                            <div className="col-md-6">
                                <h5 style={{ marginBottom: '17px' }}>{T.t('r_continue_condition')}</h5>
                                <SelectNoneAsync
                                    name={'SelectedClass'}
                                    placeHolder={T.t('r_make_select')}
                                    setSelectValue={[this.props.question!.continueEvenWrong]}
                                    // tslint:disable-next-line:jsx-no-lambda
                                    onChange={(e: any) => this.onChangeSelectCondition(e, this.props.index!)}
                                    setOptions={[{ value: true, label: T.t('r_yes') }, { value: false, label: T.t('r_no') }]}
                                />
                            </div>
                        </div>
                        {!this.state.question.continueEvenWrong &&
                            <div className="row">
                                <div className="col-md-6 d-flex align-items-center">
                                    <h5>{T.t('r_go_to_back')}</h5>
                                </div>
                                <div className="col-md-6">
                                    <DatetimeInput
                                        value={this.getTimeValue("goBackTime")}
                                        enableSeconds={true}
                                        datePickerId={"questionTimeX" + this.props.index}
                                        mode="time"
                                        maxTime={this.getTimeValue("showTime")}
                                        dateFormat={this.inputTimeFormat}
                                        isHideLabel={true}
                                        pattern={'[0-9]{2}:[0-9]{2}:[0-9]{2}'}
                                        timeFormat='00:00:00'
                                        // tslint:disable-next-line:jsx-no-lambda
                                        onChange={(e: any) => this.onChangeTextTime(e, this.props.index!, "goBackTime")}
                                    />
                                </div>
                            </div>
                        }
                        <h5 className="mt-4">{T.t('r_answer_choiche')}</h5>
                        <p>{T.t('r_question_choiches_text')}</p>
                        <div className="ans-option not-active">
                            {(this.state.question.videoTestChoices && this.state.question.videoTestChoices.length > 0) &&
                                this.state.question.videoTestChoices.map((choice, keyIndex: number) => (
                                    <React.Fragment key={Guid.create().toString()}>
                                        <div
                                            key={Guid.create().toString()}
                                            className="ans-bar tick-radio d-flex align-items-start position-relative mt-4"
                                        >
                                            <i className="material-icons menu menu-color" style={{ top: '-1px' }}>
                                                menu
                                            </i>
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line:jsx-no-lambda
                                                onChange={e => this.onChangeCheckBox(e, this.props.index!, keyIndex)}
                                                checked={choice.isAnswer}
                                                id={keyIndex.toString() + this.props.index}
                                                className="form-radio"
                                            />
                                            <label htmlFor={keyIndex.toString() + this.props.index} className="border-bottom mb-0 pb-1">
                                                {choice.choiceText}{' '}
                                                <i
                                                    onClick={this.onClickDeleteChoice.bind(this, keyIndex)}
                                                    className="material-icons del-icon del-icon-color"
                                                >
                                                    delete
                                                </i>
                                            </label>
                                        </div>
                                        <div
                                            key={Guid.create().toString()}
                                            className="ans-bar tick-radio d-flex align-items-start position-relative mt-4"
                                            style={{ marginBottom: '2rem' }}
                                        >
                                            <i className="material-icons menu menu-color" style={{ color: 'transparent' }}>
                                                menu
                                            </i>
                                            <input
                                                type="checkbox"
                                                id={Math.random().toString()}
                                                className="form-radio"
                                                readOnly={true}
                                                style={{ border: 0, cursor: 'default' }}
                                            />
                                            <label
                                                htmlFor={keyIndex.toString() + this.props.index}
                                                className="border-bottom mb-0 pb-1"
                                                style={{ opacity: 0.8 }}
                                            >
                                                {choice.feedBack}
                                            </label>
                                        </div>
                                    </React.Fragment>
                                ))}
                            <div className="form-input form-group">
                                <input
                                    name="answer"
                                    onChange={this.onChangeTextAnswer}
                                    value={this.state.inputTextAnswer}
                                    type="text"
                                    placeholder={T.t('r_write_anwser_choiche')}
                                    required={undefined}
                                />
                            </div>
                            <div className="form-input form-group">
                                <input
                                    name="feedback"
                                    onChange={this.onChangeTextfeedback}
                                    value={this.state.inputTextfeedback}
                                    type="text"
                                    placeholder={T.t('r_write_feedback_message')}
                                    required={undefined}
                                />
                            </div>
                            <button
                                onClick={this.onClickAddChoice.bind(this)}
                                className="btn btn-blue mt-4"
                                type="button"
                            >
                                <i className="material-icons mr-2">add</i>
                                <span>{T.t('r_add_choiche')}</span>
                            </button>
                            <button
                                // tslint:disable-next-line:jsx-no-lambda
                                onClick={() => this.props.deleteQuestion(this.props.index)}
                                className="btn btn-blue mt-4"
                                style={{ backgroundColor: '#ff6f61', float: 'right' }}
                                type="button"
                            >
                                <i className="material-icons mr-2">delete</i>
                                <span>{T.t('r_delete_question')}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Questions;
